import React, { Component } from "react"
import { Form } from "app/forms/form"
import * as Elements from "app/forms/elements"

import thumbnail from "app/forms/images/templates/cocoa.jpg"

class Cocoa extends Component {
  static displayName = "Cocoa"
  static style = "form"
  static formats = ["inline", "modal", "slide in"]
  static thumbnail = thumbnail
  static fields = [
    {
      name: "email_address",
      label: "Email address"
    }
  ]

  render() {
    const { elements, styles, ...props } = this.props
    const { backgroundColor: bg_color } = styles.forElement("form")
    const checkboxes_color = styles.forElement("content").color
    const borderRadius = styles.forElement("form").borderRadius

    return (
      <Form
        {...props}
        style={styles.forElement("form", {
          borderRadius: 4
        })}
      >
        <div
          data-style="full"
          style={{
            "--border-radius": borderRadius + "px"
          }}
        >
          <div
            style={styles.forElement("background")}
            className="formkit-background"
          />
          <div
            className="formkit-container"
            style={{
              "--bg-color": bg_color,
              "--bg-color-07": bg_color + "12",
              "--bg-color-83": bg_color + "D4"
            }}
          >
            <Elements.Header
              tag="h2"
              name="header"
              defaults={{ content: "Join the waitlist" }}
            />
            <Elements.Content
              name="content"
              defaults={{
                content:
                  "Subscribe below and we’ll notify you when the product is released."
              }}
            />
            <Elements.Errors />

            <Elements.CustomFields
              style={{
                color: checkboxes_color
              }}
            >
              <Elements.AddFieldButton />
              <Elements.Button
                name="submit"
                group="button"
                defaults={{ content: "Download" }}
              />
            </Elements.CustomFields>
            <Elements.Content
              name="disclaimer"
              defaults={{
                content: "We respect your privacy. Unsubscribe at any time."
              }}
            />
            <Elements.BuiltWith background="form" />
          </div>
        </div>
      </Form>
    )
  }
}

Cocoa.displayName = "Cocoa"

export default Cocoa
